module.exports = __webpack_public_path__ + "img/shipmycargo-logo.94d96eb9.png";